import { AllowedReducer, Constants } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import { Dialogs } from '@leverege/ui-elements';
import { Context } from '@leverege/plugin';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import PositionRequestDialog from './PositionRequestDialog';
import { isPositionRequestableByBusinessStateAndConfig, isPositionRequestableByStateConfigVersionNumber } from './Util';
import { isReconcilableBusinessState } from '../locatorReconciliation/Util';
const {
  t,
  tIcon
} = I18N.ns('recovr.locator.positionRequest.PositionRequestAction');
export default {
  id: 'recovr.locator.positionRequest',
  name: 'Request Locator Position',
  layout: {
    sort: 'locator.position'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    objectType: 'locator'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  isPrepared: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'locator');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return true;
    }
    const locatorId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), locatorId);
    return a.requestPosition != null;
  },
  prepare: async cxt => {
    const targets = Context.getTargetsOfType(cxt, 'locator');
    const companyId = targets[0]?.data?.data?.company?.id;
    const locationId = targets[0]?.data?.data?.location?.id;
    const locatorId = targets[0]?.id;
    const a = AllowedReducer.get(GlobalState.get(), locatorId);
    if (a.requestPosition != null) {
      return null;
    }
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      let nApi;
      if (companyId && locationId) {
        nApi = api.interface(process.env.SYSTEM_ID, 'company').obj(companyId).grp('locations').obj(locationId).grp('locators').obj(`${locatorId}`);
      } else if (companyId) {
        nApi = api.interface(process.env.SYSTEM_ID, 'company').obj(companyId).grp('locators').obj(locatorId);
      } else {
        nApi = api.interface(process.env.SYSTEM_ID, 'location').obj(locationId).grp('locators').obj(locatorId);
      }
      const res = await nApi.srv('recovr').post('requestPosition', null, {
        test: true
      });
      dispatch({
        type: Constants.ALLOWED_SET,
        resourceId: locatorId,
        action: 'requestPosition',
        allowed: res.allowed === true
      });
      return res.allowed;
    });
  },
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'locator');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    const locatorId = targets[0]?.id;
    const businessState = targets[0]?.data?.data?.businessState;
    const a = AllowedReducer.get(GlobalState.get(), locatorId);

    // disabled position request in favor of reconcile if locator is in a reconcilable business state and reconcile is allowed
    if (a.reconcile === true && isReconcilableBusinessState(businessState)) {
      return false;
    }
    return a.requestPosition === true && (isPositionRequestableByBusinessStateAndConfig(targets[0]?.data) || isPositionRequestableByStateConfigVersionNumber(targets[0]?.data));
  },
  appearance: ({
    context
  }) => {
    return {
      name: t('name'),
      icon: tIcon('icon')
    };
  },
  perform: async props => {
    const {
      context
    } = props;
    const locatorObjRef = Context.getTargetsOfType(context, 'locator')[0];
    const actions = DataSources.getActions(locatorObjRef);
    if (!locatorObjRef) {
      return;
    }
    const locator = locatorObjRef?.data;
    Dialogs.show({
      id: 'positionRequest',
      component: PositionRequestDialog,
      props: {
        actions,
        locator,
        context
      }
    });
  }
};